export default __webpack_public_path__ + "static/media/Nrusingha Tripathy.793a3f25.png";